import { type CookieConsentTranslator } from '#src/assets/lib/i18n.ts'
import { VerticalActionStack } from '#src/assets/ui/shared/components/ActionBar.tsx'
import { Button } from '#src/assets/ui/shared/components/Button.tsx'

export function SettingsDialogFooter({
  t,
  onAdjustPreferences,
  onClose,
}: {
  t: CookieConsentTranslator
  onAdjustPreferences: () => void
  onClose: () => void
}) {
  return (
    <VerticalActionStack className="lcc-settings-dialog__footer">
      <Button
        type="button"
        className="lcc-settings-dialog__btn-adjust"
        variant="primary"
        onClick={event => {
          event.stopPropagation()
          onAdjustPreferences()
        }}
      >
        {t('adjustPreferencesBtn')}
      </Button>
      <Button
        type="button"
        className="lcc-settings-dialog__btn-close"
        variant="outline"
        onClick={() => onClose()}
      >
        {t('closeIconLabel')}
      </Button>
    </VerticalActionStack>
  )
}
